import _ from "lodash";
/** external */
import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@toddle-edu/ds-web";
import classNames from "classnames";
/** relative */
import classes from "./QuestionCardTag.scss";

const QuestionCardTag = props => {
  const { label, tooltips, count, t, isSideBarPreview } = props;

  const countTextClasses = classNames({
    ["text-body-2"]: !isSideBarPreview,
    ["text-body-3"]: isSideBarPreview,

    [classes.countText]: true,
  });

  const labelClasses = classNames({
    [classes.label]: true,
    [classes.labelWidth]: !isSideBarPreview,
    [classes.previewLabelWidth]: isSideBarPreview,
  });

  return (
    <Tooltip
      tooltip={
        <div className={classes.tooltipContainer}>
          {_.map(tooltips, tooltip => {
            return <div>{tooltip}</div>;
          })}
        </div>
      }
      overlayInnerStyle={{
        maxHeight: "208px",
        overflowY: "scroll",
      }}
    >
      <div className={classes.container}>
        <div className={labelClasses}>{label}</div>
        <div>
          {count > 0 ? (
            <span className={countTextClasses}>
              {t("common:more_with_count", { count })}
            </span>
          ) : null}
        </div>
      </div>
    </Tooltip>
  );
};

QuestionCardTag.propTypes = {
  label: PropTypes.string,
  tooltip: PropTypes.string,
  count: PropTypes.number,
  isSideBarPreview: PropTypes.bool,
};

QuestionCardTag.defaultProps = {
  isSideBarPreview: false,
};

export default QuestionCardTag;
